import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const SlaCameras = {
  getAllWithSmartcatpureLane: async () => axios.get(`${API_URL}/sla_cameras/lanes/getAllWithSmartcatpureLane`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err }),
  apply: async (payload) => axios.post(`${API_URL}/sla_cameras/apply`, payload).then(({data}) => data).catch((err) => { throw err }),
};

export default SlaCameras;